/**
 * Virtual Scrolling Configuration
 * Defines thresholds and settings for when to enable virtualization
 */

export const VIRTUAL_SCROLL_CONFIG = {
  // Minimum item count before enabling virtualization
  TEAM_MEMBERS_THRESHOLD: 50,
  AUDIT_LOGS_THRESHOLD: 100,
  ORGANIZATIONS_THRESHOLD: 50,
  
  // Number of items to render outside viewport for smooth scrolling
  OVERSCAN_COUNT: 5,
  
  // Estimated item heights in pixels (used for initial calculations)
  ESTIMATED_ITEM_HEIGHT: 60,
  ESTIMATED_TABLE_ROW_HEIGHT: 65,
  
  // Container heights
  DEFAULT_CONTAINER_HEIGHT: 600,
} as const;

export type VirtualScrollConfig = typeof VIRTUAL_SCROLL_CONFIG;
